import ProposalRejectButton from "./ProposalRejectButton";
export default ProposalRejectButton;
